import type {
    CustomersFeedbackReportResponseItem,
    GetCustomersFeedbackReportServerResponse,
} from "../../../../../api/reports/customersFeedbackReport"
import type { CustomersFeedbackReportItem } from "../../../../data/types"

export const transformCustomersFeedbackReportServerData = (
    serverData: GetCustomersFeedbackReportServerResponse
): CustomersFeedbackReportItem[] =>
    serverData.content.map((data: CustomersFeedbackReportResponseItem) => ({
        id: data.feedback_id,
        orderId: data.order_id,
        feedbackTimestamp: data.feedback_timestamp,
        customerName: data.customer_name,
        customerId: data.customer_id,
        orderNumber: data.order_number,
        feedback: data.feedback,
        comment: data.comment,
    }))
